import { render, staticRenderFns } from "./ReadyToHireTalents.vue?vue&type=template&id=e6b84028&scoped=true"
import script from "./ReadyToHireTalents.vue?vue&type=script&lang=js"
export * from "./ReadyToHireTalents.vue?vue&type=script&lang=js"
import style0 from "./ReadyToHireTalents.vue?vue&type=style&index=0&id=e6b84028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b84028",
  null
  
)

export default component.exports